<template>
	<div id="background" :style="cssBack" class="bg-dark d-flex align-items-start" style="display: flex; flex-grow: 1;">
		<div class="quiz-wrapper container-fluid">

			<!-- Debug -->
			<div v-if="$tracker.debug" class="row bg-light m-2" style="position: absolute; left: 0; bottom: 0; width: 350px; max-height: 500px; overflow-y: auto;">
				<div v-for="(question,index) in selectedQuestions" :key="index" class="row p-1 m-0 debug-question" :class="{ selected: selectedIndex == index }" :style="{ 'background': (index%2==0 ? 'var(--bs-gray-300)' : 'var(--bs-light)') }" @click="selectedIndex = index">
					<div class="col-1 text-muted">{{ index+1 }}</div>
					<div class="col-2">{{ question.id }}</div>
					<div class="col-3">{{ question.mechanic.replace('sort', 'sorting') }}</div>
					<div class="col-2">{{ question.type }}</div>
					<div class="col-2">{{ question.hierarchy }}</div>
					<div class="col-2">{{ question.difficulty }}</div>
				</div>
			</div>

			<!-- Quiz window -->
			<div class="quiz-window rounded-box">

				<!-- Top panel -->
				<div class="rounded-box m-2 p-4">

					<!-- Progress text -->

					<!-- Progress bar wrapper -->
					<div class="position-relative">
						<!-- <b class="position-absolute start-0 top-0">{{ currentQuestion.id }}</b> -->
						<!-- Text -->
						<div class="progress-text text-muted">
							{{ $t('quiz_progress') }}
						</div>
						<!-- Bar -->
						<div class="progress">
							<div class="progress-bar progress-bar-striped bg-warning" :style="progressStyle"></div>
						</div>
						<!-- Dots -->
						<div class="progress-dots no-select">
							<div v-for="(question, index) in selectedQuestions" :key="index" class="progress-dot"
								:class="{
									'dot-complete': isQuestionComplete(question.id),
									'dot-active': (index == selectedIndex),
									'dot-incomplete': !isQuestionComplete(question.id) && (index != selectedIndex)
								}"
								@click="goto(index)">
								<span v-if="isQuestionComplete(question.id)">
									<b-icon class="in-dot-icon" icon="check"></b-icon>
									<!-- {{ index+1 }} -->
								</span>
								<span v-else>{{ index+1 }}</span>
							</div>
						</div>
					</div>

				</div>


				<!-- Middle panel: Question -->
				<div v-if="currentQuestion" class="rounded-box m-2 p-4">

					<MultiChoice v-if="currentQuestion.mechanic == 'mcq'" :question="currentQuestion" :selectedIndex="selectedIndex" @complete="onQuestionComplete" @progress="onQuestionProgress" />
					<FillInBlanks v-else-if="currentQuestion.mechanic == 'blanks'" :question="currentQuestion" :selectedIndex="selectedIndex" @complete="onQuestionComplete" @progress="onQuestionProgress" />
					<Sequence v-else-if="currentQuestion.mechanic == 'sequence'" :question="currentQuestion" :selectedIndex="selectedIndex" @complete="onQuestionComplete" @progress="onQuestionProgress" />
					<Sorting v-else-if="currentQuestion.mechanic == 'sort'" :question="currentQuestion" :selectedIndex="selectedIndex" @complete="onQuestionComplete" @progress="onQuestionProgress" />
					<div v-else>
						<p class="mt-4">Unsupported question format: {{ currentQuestion.mechanic }}</p>
						<button @click="progress">Skip</button>
					</div>
				</div>

				<!-- Middle panel: Start page -->
				<div v-else-if="isRunning" class="rounded-box m-2 p-4">
					<h2>{{ $t('quiz_title') }}</h2>
					<hr class="my-4">
					<p>{{ getText(taskId, 'introduction') }}</p>
					<p>{{ $t('quiz_start') }}</p>
					<button class="btn px-5 my-2 btn-primary progress-bar-striped progress-bar-animated" @click="start">
						<span>
							{{ $t('quiz_button_start') }}
						</span>
					</button>
				</div>

				<!-- Middle panel: Evaluation -->
				<div v-else-if="evaluationText && !$tracker.isTaskEvaluated(taskId)" class="evaluation-box rounded-box m-2 p-4">
					<p v-html="getText(evaluationText)"></p>

					<!-- <hr>
					<Rating
						ref="rateFun"
						min=1
						max=5
						textQuestion="fun_question"
						textLeft="fun_scale_negative"
						textCenter="fun_scale_medium"
						textRight="fun_scale_positive"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rateInstructive"
						min=1
						max=5
						textQuestion="instructive_question"
						textLeft="instructive_scale_negative"
						textCenter="instructive_scale_medium"
						textRight="instructive_scale_positive"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rateInteresting"
						min=1
						max=5
						textQuestion="interesting_question"
						textLeft="interesting_scale_negative"
						textCenter="interesting_scale_medium"
						textRight="interesting_scale_positive"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr> -->

					<hr>
					<Rating
						ref="rating1"
						min=1
						max=7
						textQuestion="evaluation_question_1"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rating2"
						min=1
						max=7
						textQuestion="evaluation_question_2"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rating3"
						min=1
						max=7
						textQuestion="evaluation_question_3"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rating4"
						min=1
						max=7
						textQuestion="evaluation_question_4"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rating5"
						min=1
						max=7
						textQuestion="evaluation_question_5"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rating6"
						min=1
						max=7
						textQuestion="evaluation_question_6"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rating7"
						min=1
						max=7
						textQuestion="evaluation_question_7"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>
					<Rating
						ref="rating8"
						min=1
						max=7
						textQuestion="evaluation_question_8"
						textLeft="strongly_disagree"
						textCenter=""
						textRight="strongly_agree"
						style="width: 60%;"
						@select="updateQuizEvaluation"></Rating>
					<hr>

					<button
						class="btn px-5 my-2 progress-bar-striped progress-bar-animated"
						:class="{
							'btn-primary': quizEvaluationFilled,
							'btn-secondary': !quizEvaluationFilled,
							'progress-bar-animated': quizEvaluationFilled
						}"
						:disabled="!quizEvaluationFilled"
						@click="submitQuizFeedback"
					>
						<span>{{ $t('login_submit') }}</span>
					</button>
				</div>

				<!-- Middle panel: Completion page -->
				<div v-else class="rounded-box m-2 p-4">
					<h2>{{ $t('quiz_complete_title') }}</h2>
					<hr class="my-4">

					<div v-if="taskId != 'm3_c2'">
						<p>{{ $t('quiz_complete_text') }}</p>
					</div>
					<div v-else>
						<p>{{ getText('evaluation_end_text') }}</p>
					</div>

					<hr>

					<router-link
						class="btn px-5 my-2 btn-success progress-bar-striped progress-bar-animated"
						:to="{ name: 'Module', params: { moduleName, fromTaskName: taskName } }"
						@click.native="next"
					>
						<span v-if="taskId != 'm3_c2'">
							{{ $t('continue') }}
						</span>
						<span v-else>
							{{ $t('finish') }}
						</span>
					</router-link>
				</div>


				<!-- Difficulty rating -->
				<div v-show="showEvaluation" class="rounded-box m-2 p-1">
					<Rating
						ref="rateDifficulty"
						min=0
						max=10
						textQuestion="difficulty_question"
						textLeft="difficulty_scale_easy"
						textCenter="difficulty_scale_medium"
						textRight="difficulty_scale_hard"
						style="width: 70%;"
						@select="updateQuestionEvaluation"
					></Rating>

					<button
						class="btn px-5 mb-4 progress-bar-striped progress-bar-animated"
						:class="{
							'btn-success': questionEvaluationFilled,
							'btn-secondary': !questionEvaluationFilled,
							'progress-bar-animated': questionEvaluationFilled
						}"
						:disabled="!questionEvaluationFilled"
						@click="submitQuestionFeedback"
					>
						<span>{{ $t('continue') }}</span>
					</button>
				</div>

			</div>
		</div>
	</div>
</template>



<script>
import MultiChoice from '@/components/Quiz/MultiChoice.vue';
import FillInBlanks from '@/components/Quiz/FillInBlanks.vue';
import Sequence from '@/components/Quiz/Sequence.vue';
import Sorting from '@/components/Quiz/Sorting.vue';
import Rating from '@/components/Rating.vue';

export default {
	props: [ "moduleName", "taskName" ],
	components: { MultiChoice, FillInBlanks, Sequence, Sorting, Rating },
	data() {
		return {
			sessionLoaded: !!this.$tracker.session,
			taskLoaded: false,
			taskId: this.routeToId(this.moduleName, this.taskName),
			isRunning: true,

			showEvaluation: false,
			quizEvaluationFilled: false,
			questionEvaluationFilled: false,

			// allQuestions: [],
			selectedQuestions: [],
			completedQuestions: [],
			currentQuestion: null,
			evaluationText: null,

			selectedIndex: -1,
			progressIndex: -1,
			quizMax: 6,
			progressStyle: "width: 0%;",

			cssBack: { backgroundImage: `url(${require(`@/assets/backgrounds/quiz_dark.jpg`)})` },
		};
	},
	mounted() {
		// Fetch task data
		this.fetch(`/api/get_task/${this.moduleName}/${this.taskName}`, data => {
			if (data) {
				this.data = data;

				this.taskLoaded = true;
				if (this.sessionLoaded) {
					this.onTaskLoad();
				}
			}
			else {
				console.error("Error in Quiz fetch:", this.fetchError);
				this.$router.replace({ name: 'Home' });
			}
		});
	},
	methods: {
		onSessionLoad() {
			this.$forceUpdate();
			this.updateProgress();

			// Temporary block for pilot
			// if (!this.$tracker.debug && (this.moduleName == 'module-3' || (this.moduleName == 'module-2' && ['task-4a', 'task-4b', 'task-5', 'task-6a', 'task-6b', 'quiz-2'].includes(this.taskName)))) {
				// this.$router.replace(`/${this.moduleName}`);
				// return;
			// }

			this.sessionLoaded = true;
			if (this.taskLoaded) {
				this.onTaskLoad();
			}
		},

		onTaskLoad() {
			this.selectedQuestions = this.data.questions;
			this.quizMax = this.data.questions.length;
			this.evaluationText = this.data.evaluation_text;

			this.updateProgress();

			this.$log.onTaskStart(this.taskId, "quiz", null, this.$tracker.performance);
			// this.$tracker.onTaskStart(this.taskId, "quiz", null);
		},

		isQuestionComplete(questionId) {
			// return this.completedQuestions.includes(questionId) && this.$tracker.isTaskEvaluated(questionId);
			return this.$tracker.isTaskComplete(questionId);
		},

		isQuizStarted() {
			if (this.selectedQuestions.length > 0) {
				return this.selectedQuestions.some(question => this.isQuestionComplete(question.id));
			}
		},

		isQuizComplete() {
			if (this.selectedQuestions.length > 0) {
				return this.selectedQuestions.every(question => this.isQuestionComplete(question.id));
			}
		},

		onQuestionComplete() {
			this.completedQuestions.push(this.currentQuestion.id);
			// this.completedIndicies.push(this.quizIndex);
			this.updateProgressIndex();
		},

		onQuestionProgress() {
			// if (this.$tracker.isTaskEvaluated(this.currentQuestion.id)) {
			this.onQuizProgress();
			// }
			// else {
			// 	this.showEvaluation = true;
			// }
		},

		onQuizProgress() {
			this.showEvaluation = false;
			if (this.isQuizComplete()) {
				this.selectedIndex = this.selectedQuestions.length;
			}
			else {
				let limit = 100;
				do {
					this.selectedIndex = (this.selectedIndex + 1) % this.quizMax;
				}
				while (this.isQuestionComplete(this.selectedQuestions[this.selectedIndex].id) && limit-- > 0);

				if (limit < 1) {
					this.selectedIndex = this.selectedQuestions.length;
				}
			}
		},

		start() {
			this.onQuizProgress();
		},

		goto(index) {
			this.selectedIndex = index;
		},

		onComplete() {
			this.currentQuestion = null;
			this.isRunning = false;

			if (!this.$tracker.isTaskComplete(this.taskId) && (!this.evaluationText || this.$tracker.isTaskEvaluated(this.taskId))) {
				this.$log.onTaskComplete(this.taskId);
				this.$tracker.onTaskStart(this.taskId);
				this.$tracker.onTaskComplete(this.taskId, 0);
			}

			// Reset difficulty rating
			// if (this.$refs.rateFun) {
			// 	const feedback = this.$tracker.evaluatedTasks[this.taskId];
			// 	this.$refs.rateFun.reset(feedback[0]);
			// 	this.$refs.rateInstructive.reset(feedback[1]);
			// 	this.$refs.rateInteresting.reset(feedback[2]);
			// }

			if (this.$refs.rating1) {
				const feedback = this.$tracker.evaluatedTasks[this.taskId];
				this.$refs.rating1.reset(feedback[0]);
				this.$refs.rating2.reset(feedback[1]);
				this.$refs.rating3.reset(feedback[2]);
				this.$refs.rating4.reset(feedback[3]);
				this.$refs.rating5.reset(feedback[4]);
				this.$refs.rating6.reset(feedback[5]);
				this.$refs.rating7.reset(feedback[6]);
				this.$refs.rating8.reset(feedback[7]);
			}
		},

		next() {
			this.$log.onTaskNext(this.taskId);
		},


		updateQuizEvaluation() {
			if (this.$refs) {
				// this.quizEvaluationFilled = (this.$refs.rateFun.filled && this.$refs.rateInstructive.filled && this.$refs.rateInteresting.filled);
				this.quizEvaluationFilled = (
					this.$refs.rating1.filled &&
					this.$refs.rating2.filled &&
					this.$refs.rating3.filled &&
					this.$refs.rating4.filled &&
					this.$refs.rating5.filled &&
					this.$refs.rating6.filled &&
					this.$refs.rating7.filled &&
					this.$refs.rating8.filled
				);
			}
		},

		updateQuestionEvaluation() {
			if (this.$refs) {
				this.questionEvaluationFilled = this.$refs.rateDifficulty.filled;
			}
		},

		submitQuizFeedback() {
			if (this.$refs) {
				// this.$tracker.onQuizFeedback(this.taskId, this.$refs.rateFun.selected, this.$refs.rateInstructive.selected, this.$refs.rateInteresting.selected);
				this.$tracker.onQuizFeedback(
					this.taskId,
					this.$refs.rating1.selected,
					this.$refs.rating2.selected,
					this.$refs.rating3.selected,
					this.$refs.rating4.selected,
					this.$refs.rating5.selected,
					this.$refs.rating6.selected,
					this.$refs.rating7.selected,
					this.$refs.rating8.selected,
				);
				this.onQuizProgress();
				this.updateProgress();

				if (this.isQuizComplete()) {
					this.onComplete();
					this.$forceUpdate();
				}
			}
		},

		submitQuestionFeedback() {
			if (this.$refs) {
				this.$tracker.onQuestionFeedback(this.currentQuestion.id, this.$refs.rateDifficulty.selected);
				this.onQuizProgress();
				this.updateProgress();
			}
		},

		updateProgress() {
			for (const id of this.$tracker.completedTasks) {
				if (this.$tracker.isTaskEvaluated(id)) {
					if (!this.completedQuestions.includes(id)) {
						this.completedQuestions.push(id);
					}
				}
			}

			this.updateProgressIndex();

			if (this.isQuizComplete()) {
				this.selectedIndex = this.selectedQuestions.length;
			}
		},

		updateProgressIndex() {
			if (this.selectedQuestions.length > 0) {
				this.progressIndex = 0;
				for (const question of this.selectedQuestions) {
					if (this.isQuestionComplete(question.id))
						this.progressIndex++;
					else
						break;
				}
			}
		},
	},
	computed: {},
	watch: {
		selectedIndex() {
			if (this.selectedIndex < this.selectedQuestions.length) {
				this.currentQuestion = this.selectedQuestions[this.selectedIndex];

				// Reset difficulty rating
				if (this.$refs.rateDifficulty && this.currentQuestion) {
					this.$refs.rateDifficulty.reset(this.$tracker.evaluatedTasks[this.currentQuestion.id]);
				}

				this.showEvaluation = false;
				// if (this.$tracker.isTaskComplete(this.currentQuestion.id)) {
				// 	this.showEvaluation = true;
				// }
			}
			else {
				this.onComplete();
			}
		},
		progressIndex() {
			let perc = Math.floor(100 * (this.progressIndex) / (this.quizMax - 1));
			this.progressStyle = `width: ${perc}%;`;
		},
	},
};
</script>



<style scoped>
	#background {
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
	}

	.quiz-wrapper {
		max-width: 1000px;
		margin: auto;
		text-align: center;
		transition: all .5s linear;
	}
	@media only screen and (min-width: 1000px) {
		.quiz-wrapper {
			/*width: 1000px;*/
		}
	}

	.quiz-window {
		background-color: white;
		margin: 1.5em;
		padding: 0.1em;
	}

	/deep/ .rounded-box {
		border: 1px solid #CCC;
		border-radius: 0.4em;
		box-shadow: 0 2px 6px #00000022;
	}

	.progress {
		margin: auto;
		left: 25%;
		width: 50%;
		height: 0.6em;
		background-color: #ddd;
		transition: all 0.5s ease;
	}

	.progress-text {
		position: absolute;
		right: calc(75% + 2em);
		top: 50%;
		font-size: 0.7em;
		transform: translate(0, -50%);
	}

	.progress-dots {
		left: 25%;
		width: 50%;
		top: 50%;
		font-size: 0.7em;

		position: absolute;
		display: flex;
		justify-content: space-between;
	}

	.progress-dot {
		width: 28px;
		height: 28px;
		font-weight: bold;
		line-height: calc(28px - 2*3px);
		border-radius: 100%;
		transform: translate(0, -50%);

		transition: all 0.3s ease;
		/*transition-delay: 0.3s;*/
		cursor: pointer;
	}

	.dot-complete {
		background-color: var(--bs-warning);
		border: 3px solid white;
		color: rgba(0, 0, 0, 0.6);
		/*width: 24px;*/
		/*height: 24px;*/
		font-size: 1.5em;
	}

	.dot-active {
		background-color: #ffe;
		border: 3px solid var(--bs-warning);
		/*width: 28px;*/
		/*height: 28px;*/
	}
	.dot-active.dot-complete {
		font-size: 1.7em;
	}

	.dot-incomplete {
		background-color: #ccc;
		border: 3px solid white;
		color: rgba(0, 0, 0, 0.6);
	}

	.in-dot-icon {
		position: absolute;
		top: 50%;
		transform: translate(-50%, -50%);
	}


	.debug-question.selected {
		background-color: var(--bs-warning) !important;
	}
	.debug-question:hover {
		background-color: var(--bs-warning) !important;
		cursor: pointer;
	}


	.evaluation-box {
		max-height: 75vh;
		overflow-y: auto;
	}

</style>
